export const LOCAL_STORAGE_VERSION = "1.0.0";
export const FULL_WIDTH_CHARACTERS = ["％", "＠", "＄", "ｓ", "ｄ", "ｆ", "０", "１", "２", "３", "４", "５", "６", "７", "８", "９"];
export const HALF_WIDTH_CHARACTERS = ["%", "@", "$", "s", "d", "f", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
export const PLATFORM_ANDROID = "Android";
export const PLATFORM_IOS = "iOS";
export const PLATFORM_FLUTTER = "Flutter";
export const PLATFORM_I18NEXT = "i18next";
export const PLATFORM_PHP_LARAVEL = "PHP Laravel";
export const ANDROID_RESOURCE_FILENAME = "strings.xml";
export const ANDROID_XML_TAG_RESOURCES = "resources";
export const ANDROID_XML_TAG_STRING = "string";
export const ANDROID_XML_ATTRIBUTE_NAME = "name";
export const ANDROID_XML_ATTRIBUTE_TRANSLATABLE = "translatable";
export const IOS_RESOURCE_FILENAME = "Localizable.strings";
export const IOS_INFO_PLIST = "InfoPlist";
export const TEMPLATE_FILE_NAME = "template";
export const EXCEL_EXTENSION = "xlsx";
export const KEY = "Key";
export const KEY_MACRO = "(key) => {\n    //Return a string with a given key.\n    return key;\n};";
export const VALUE_MACRO = "(value) => {\n    //Return a string with a given value.\n    return value;\n};";
export const EXCEL_SHEET_NAME_LIMIT = 31;
export const LANGUAGE_CODES = [{
    name: "English",
    android: "values",
    ios: "Base.lproj",
    flutter: "intl_en.arb",
    i18next: "en",
    phpLaravel: "en"
}, {
    name: "French",
    android: "values-fr",
    ios: "fr.lproj",
    flutter: "intl_fr.arb",
    i18next: "fr",
    phpLaravel: "fr"
}, {
    name: "German",
    android: "values-de",
    ios: "de.lproj",
    flutter: "intl_de.arb",
    i18next: "de",
    phpLaravel: "de"
}, {
    name: "Chinese (Simplified)",
    android: "values-zh-rCN",
    ios: "zh-Hans.lproj",
    flutter: "intl_zh_Hans.arb",
    i18next: "zh-CN",
    phpLaravel: "zh-CN"
}, {
    name: "Chinese (Traditional)",
    android: "values-zh-rTW",
    ios: "zh-Hant.lproj",
    flutter: "intl_zh_Hant.arb",
    i18next: "zh-TW",
    phpLaravel: "zh-TW"
}, {
    name: "Japanese",
    android: "values-ja",
    ios: "ja.lproj",
    flutter: "intl_ja.arb",
    i18next: "ja",
    phpLaravel: "ja"
}, {
    name: "Spanish",
    android: "values-es",
    ios: "es.lproj",
    flutter: "intl_es.arb",
    i18next: "es",
    phpLaravel: "es"
}, {
    name: "Italian",
    android: "values-it",
    ios: "it.lproj",
    flutter: "intl_it.arb",
    i18next: "it",
    phpLaravel: "it"
}, {
    name: "Dutch",
    android: "values-nl",
    ios: "nl.lproj",
    flutter: "intl_nl.arb",
    i18next: "nl",
    phpLaravel: "nl"
}, {
    name: "Korean",
    android: "values-ko",
    ios: "ko.lproj",
    flutter: "intl_ko.arb",
    i18next: "ko",
    phpLaravel: "ko"
}, {
    name: "Portuguese",
    android: "values-pt",
    ios: "pt.lproj",
    flutter: "intl_pt.arb",
    i18next: "pt",
    phpLaravel: "pt"
}, {
    name: "Danish",
    android: "values-da",
    ios: "da.lproj",
    flutter: "intl_da.arb",
    i18next: "da",
    phpLaravel: "da"
}, {
    name: "Finnish",
    android: "values-fi",
    ios: "fi.lproj",
    flutter: "intl_fi.arb",
    i18next: "fi",
    phpLaravel: "fi"
}, {
    name: "Norwegian Bokmål",
    android: "values-nb",
    ios: "nb.lproj",
    flutter: "intl_nb.arb",
    i18next: "nb",
    phpLaravel: "nb"
}, {
    name: "Swedish",
    android: "values-sv",
    ios: "sv.lproj",
    flutter: "intl_sv.arb",
    i18next: "sv",
    phpLaravel: "sv"
}, {
    name: "Russian",
    android: "values-ru",
    ios: "ru.lproj",
    flutter: "intl_ru.arb",
    i18next: "ru",
    phpLaravel: "ru"
}, {
    name: "Polish",
    android: "values-pl",
    ios: "pl.lproj",
    flutter: "intl_pl.arb",
    i18next: "pl",
    phpLaravel: "pl"
}, {
    name: "Turkish",
    android: "values-tr",
    ios: "tr.lproj",
    flutter: "intl_tr.arb",
    i18next: "tr",
    phpLaravel: "tr"
}, {
    name: "Arabic",
    android: "values-ar",
    ios: "ar.lproj",
    flutter: "intl_ar.arb",
    i18next: "ar",
    phpLaravel: "ar"
}, {
    name: "Thai",
    android: "values-th",
    ios: "th.lproj",
    flutter: "intl_th.arb",
    i18next: "th",
    phpLaravel: "th"
}, {
    name: "Czech",
    android: "values-cs",
    ios: "cs.lproj",
    flutter: "intl_cs.arb",
    i18next: "cs",
    phpLaravel: "cs"
}, {
    name: "Hungarian",
    android: "values-hu",
    ios: "hu.lproj",
    flutter: "intl_hu.arb",
    i18next: "hu",
    phpLaravel: "hu"
}, {
    name: "Catalan",
    android: "values-ca",
    ios: "ca.lproj",
    flutter: "intl_ca.arb",
    i18next: "ca",
    phpLaravel: "ca"
}, {
    name: "Croatian",
    android: "values-hr",
    ios: "hr.lproj",
    flutter: "intl_hr.arb",
    i18next: "hr",
    phpLaravel: "hr"
}, {
    name: "Greek",
    android: "values-el",
    ios: "el.lproj",
    flutter: "intl_el.arb",
    i18next: "el",
    phpLaravel: "el"
}, {
    name: "Hebrew",
    android: "values-iw",
    ios: "he.lproj",
    flutter: "intl_he.arb",
    i18next: "he",
    phpLaravel: "he"
}, {
    name: "Romanian",
    android: "values-ro",
    ios: "ro.lproj",
    flutter: "intl_ro.arb",
    i18next: "ro",
    phpLaravel: "ro"
}, {
    name: "Slovak",
    android: "values-sk",
    ios: "sk.lproj",
    flutter: "intl_sk.arb",
    i18next: "sk",
    phpLaravel: "sk"
}, {
    name: "Slovenian",
    android: "values-sl",
    ios: "sl.lproj",
    flutter: "intl_sl.arb",
    i18next: "sl",
    phpLaravel: "sl"
}, {
    name: "Ukrainian",
    android: "values-uk",
    ios: "uk.lproj",
    flutter: "intl_uk.arb",
    i18next: "uk",
    phpLaravel: "uk"
}, {
    name: "Indonesian",
    android: "values-in",
    ios: "id.lproj",
    flutter: "intl_id.arb",
    i18next: "id",
    phpLaravel: "id"
}, {
    name: "Malay",
    android: "values-ms",
    ios: "ms.lproj",
    flutter: "intl_ms.arb",
    i18next: "ms",
    phpLaravel: "ms"
}, {
    name: "Vietnamese",
    android: "values-vi",
    ios: "vi.lproj",
    flutter: "intl_vi.arb",
    i18next: "vi",
    phpLaravel: "vi"
}, {
    name: "Bulgarian",
    android: "values-bg",
    ios: "bg.lproj",
    flutter: "intl_bg.arb",
    i18next: "bg",
    phpLaravel: "bg"
}];
